import React, { useState } from 'react'
import { Switch, Route, useHistory } from 'react-router-dom'
import ARoute from '../authRoute'
import UpdateUser from '../../view/Content/user/update'
import { Breadcrumb, Button, Tooltip, ConfigProvider, Empty } from 'antd'
import { EyeOutlined } from '@ant-design/icons'
import { useSelector } from 'react-redux'
import { SmileOutlined } from '@ant-design/icons';
import enUS from 'antd/es/locale/en_US';
import zhCN from 'antd/es/locale/zh_CN';
export default function Content(props) {
    let prePath = "/view";//attention 此处固定写了 /view
    // 获取当前语言
    const langValue = useSelector(state => state.langList.value)
    // 获取表单数据
    const menulist = useSelector(state => state.menuList.value)
    const [customize, setCustomize] = useState(true)
    // const [locale,setLocale] = useState(zhCN)
    // if(langValue==2){
    //     setLocale(enUS)
    // }else {
    //     setLocale(zhCN)
    // }
    // console.log(menulist);
    /**自动化工程，webpack API require */
    const files = require.context('../../view/Content', true, /(\.js|\.tsx)$/);
    let routeList = [];
    files.keys().map((key, i) => {
        let path = key.split("\.")[1];
        routeList.push({
            path: path,//目录相对路径
            component: files(key).default //type：function，组件；等同于import XXX中的XXX
        })
        // console.log("******path:", path);
    });

    routeList.push({ path: "/user/update/:id", UpdateUser });
    let { breadCrumbArr } = props;
    //history跳转时，更改面包屑
    let history = useHistory();
    let localPathName = history.location.pathname;
    if (/\/view\/user\/update/.test(localPathName)) {
        //弹窗
        breadCrumbArr[1] = '编辑用户';
    }
    else if (/\/view\/bill\/add/.test(localPathName)) {
        breadCrumbArr = ['票据作业', '新建票据'];
    }
    else if (/\/view\/bill\/list/.test(localPathName)) {
        breadCrumbArr = ['票据作业', '票据列表'];
    }
    else if (/\/view\/billmgt\/processing/.test(localPathName)) {

        breadCrumbArr = ['票据管理', '待处理列表'];
    }
    else if (/\/view\/billmgt\/served/.test(localPathName)) {

        breadCrumbArr = ['票据管理', '已处理列表'];
    }
    else if (/\/view\/user\/list/.test(localPathName)) {

        breadCrumbArr = ['用户管理', '用户列表'];
    }
    // 中英文转换
    if (breadCrumbArr.length > 0 && menulist.length > 0) {
        breadCrumbArr.forEach((item, index) => {
            var obj = menulist.find(item2 => (item.includes(item2.menu_name) || item.includes(item2.en_menu_name)))
            if (obj != undefined) {
                if (langValue == 0) {
                    breadCrumbArr[index] = obj.menu_name + `(${obj.en_menu_name})`
                } else if (langValue == 1) {
                    breadCrumbArr[index] = obj.menu_name
                } else {
                    breadCrumbArr[index] = obj.en_menu_name
                }
            }

        })
    }

    // console.log('***PATHNAME:', history.location.pathname);

    //护眼模式颜色
    const [eyeCare, setEyeCare] = useState('white');
    const customizeRenderEmpty = () => (
        <Empty
            description={
                <>{langValue == 0 ? <>暂无数据<br />No data yet</> : (langValue == 1 ? '暂无数据' : 'No data yet')}</>
            }
            image={Empty.PRESENTED_IMAGE_SIMPLE}
        />
    );

    return (
        <ConfigProvider locale={langValue == 2 ? enUS : zhCN} renderEmpty={customize ? customizeRenderEmpty : undefined}>


            <Tooltip title="护眼模式">
                <Button
                    icon={<EyeOutlined />}
                    id='eyeBtn'
                    style={{
                        fontSize: '18px',
                        position: 'fixed',
                        height: 50,
                        width: 50,
                        bottom: 40,
                        right: 40,
                        border: '0px',
                        borderRadius: '50%',
                        textAlign: 'center',
                        background: '#DEF1EF',
                        zIndex: '9999'
                    }}
                    onClick={() => {

                        if (eyeCare == 'white') {
                            let eyeBtn = document.getElementById('eyeBtn');
                            eyeBtn.style.background = '#f6f0da';

                            var styleSheets = document.styleSheets[0]; //获取样式表引用
                            var index = styleSheets.length; //获取样式表中包含样式的个数

                            //整体body颜色
                            document.body.style.backgroundColor = '#DEF1EF';

                            styleSheets.insertRule(".webpage-header {background-color: #DEF1EF !important;}", index);
                            styleSheets.insertRule(".ant-layout-content {background-color: #DEF1EF !important;}", index);
                            styleSheets.insertRule(".ant-pro-card-body {background-color: #DEF1EF !important;}", index);
                            styleSheets.insertRule(".ant-table-thead>tr>th {background-color: #DEF1EF !important;}", index);
                            styleSheets.insertRule(".ant-table-tbody>tr>td {background-color: #DEF1EF !important;}", index);
                            styleSheets.insertRule(".ant-pro-table-search {background-color: #DEF1EF !important;}", index);
                            styleSheets.insertRule(".bill-table-container {background-color: #DEF1EF !important;}", index);
                            styleSheets.insertRule(".add-bill {background-color: #DEF1EF !important;}", index);
                            styleSheets.insertRule(".add-user {background-color: #DEF1EF !important;}", index);
                            styleSheets.insertRule(".ant-tree {background-color: #DEF1EF !important;}", index);
                            styleSheets.insertRule(".ant-col {background-color: #DEF1EF !important;}", index);
                            styleSheets.insertRule(".mddtl-header {background-color: #DEF1EF !important;}", index);
                            styleSheets.insertRule(".capital {background-color: #DEF1EF !important;}", index);
                            styleSheets.insertRule(".ant-menu {background-color: #DEF1EF !important;}", index);
                            styleSheets.insertRule(".ant-layout-sider-children {background-color: #DEF1EF !important;}", index);
                            styleSheets.insertRule(".login-wrapper .form-wrapper .login-form {background-color: #DEF1EF !important;}", index);
                            styleSheets.insertRule(".ant-modal-body {background-color: #DEF1EF !important;}", index);
                            styleSheets.insertRule(".ant-modal-header {background-color: #DEF1EF !important;}", index);

                            setEyeCare('green');

                        } else if (eyeCare == 'green') {

                            let eyeBtn = document.getElementById('eyeBtn');
                            eyeBtn.style.background = 'white';

                            var styleSheets = document.styleSheets[0]; //获取样式表引用
                            var index = styleSheets.length; //获取样式表中包含样式的个数
                            //整体body颜色
                            document.body.style.backgroundColor = '#f6f0da';

                            for (const cr of styleSheets.cssRules) {
                                cr ?.style ?.removeProperty('background-color');
                            }

                            styleSheets.insertRule(".webpage-header {background-color: #f6f0da !important;}", index);
                            styleSheets.insertRule(".ant-layout-content {background-color: #f6f0da !important;}", index);
                            styleSheets.insertRule(".ant-pro-card-body {background-color: #f6f0da !important;}", index);
                            styleSheets.insertRule(".ant-table-thead>tr>th {background-color: #f6f0da !important;}", index);
                            styleSheets.insertRule(".ant-table-tbody>tr>td {background-color: #f6f0da !important;}", index);
                            styleSheets.insertRule(".ant-pro-table-search {background-color: #f6f0da !important;}", index);
                            styleSheets.insertRule(".bill-table-container {background-color: #f6f0da !important;}", index);
                            styleSheets.insertRule(".add-bill {background-color: #f6f0da !important;}", index);
                            styleSheets.insertRule(".add-user {background-color: #f6f0da !important;}", index);
                            styleSheets.insertRule(".ant-tree {background-color: #f6f0da !important;}", index);
                            styleSheets.insertRule(".ant-col {background-color: #f6f0da !important;}", index);
                            styleSheets.insertRule(".mddtl-header {background-color: #f6f0da !important;}", index);
                            styleSheets.insertRule(".capital {background-color: #f6f0da !important;}", index);
                            styleSheets.insertRule(".ant-menu {background-color: #f6f0da !important;}", index);
                            styleSheets.insertRule(".ant-layout-sider-children {background-color: #f6f0da !important;}", index);
                            styleSheets.insertRule(".login-wrapper .form-wrapper .login-form {background-color: #f6f0da !important;}", index);
                            styleSheets.insertRule(".ant-modal-body {background-color: #f6f0da !important;}", index);
                            styleSheets.insertRule(".ant-modal-header {background-color: #f6f0da !important;}", index);

                            setEyeCare('yellow');

                        } else {
                            let eyeBtn = document.getElementById('eyeBtn');
                            eyeBtn.style.background = '#DEF1EF';

                            var styleSheets = document.styleSheets[0]; //获取样式表引用
                            var index = styleSheets.length; //获取样式表中包含样式的个数
                            //整体body颜色
                            document.body.style.backgroundColor = '#fff';

                            for (const cr of styleSheets.cssRules) {
                                cr ?.style ?.removeProperty('background-color');
                            }

                            setEyeCare('white');

                        }
                    }}
                >
                </Button>
            </Tooltip>
            {/*面包屑*/}
            <Breadcrumb separator=">" style={{ margin: '-2px 0 16px 0' }}>
                {breadCrumbArr.map((b, i) => {
                    return (<Breadcrumb.Item index={i} key={i} style={{ color: '#666666', fontSize: '15px', fontWeight: '600' }}>{b}</Breadcrumb.Item>)
                })}
            </Breadcrumb>
            <Switch>
                {
                    //读取view目录下的js文件，动态生成路由；'/view/bill/list' .etc  
                    routeList.map((route) => {
                        let Component = route.component;
                        let path = prePath + route.path; //  
                        return <ARoute path={path} component={Component} key={path} />
                    })
                }
                <Route path={prePath} exact> <h1 >页面跳转中...{prePath}</h1> </Route>
                <Route > <h1 ><font color='orange'>  页面暂未开放，敬请期待：）  </font></h1> </Route>
            </Switch>
        </ConfigProvider>
    )
}
